module.exports = __webpack_public_path__ + "img/background2.3fba396d.png";